const ROUTE_ALIASES = {
    '/masterdata?mode=view': [{ pathname: '/bomlist', search: '?mode=view', includeDescendants: true }],
    '/masterdata?mode=edit': [{ pathname: '/bomlist', search: '?mode=edit', includeDescendants: true }]
};

function matchesRoute({ pathname, search }, route) {
    if (route.search !== undefined && search !== route.search) return false;
    if (pathname === route.pathname) return true;
    return route.includeDescendants === true
        && route.pathname !== '/'
        && pathname.startsWith(`${route.pathname}/`);
}

function isSidebarRouteActive(location, target) {
    if (!target) return false;

    const [pathname, query] = target.split('?');
    const targetRoute = {
        pathname,
        search: query === undefined ? undefined : `?${query}`,
        includeDescendants: query === undefined
    };

    return [targetRoute, ...(ROUTE_ALIASES[target] || [])].some(route => matchesRoute(location, route));
}

module.exports = { isSidebarRouteActive };
